__turbopack_context__.v({
  "controls": "PrVpVa_controls",
  "fadeInOut": "PrVpVa_fadeInOut",
  "iosScroll": "PrVpVa_iosScroll",
  "noFullscreenButton": "PrVpVa_noFullscreenButton",
  "playButton": "PrVpVa_playButton",
  "playButtonIn": "PrVpVa_playButtonIn",
  "playIndicator": "PrVpVa_playIndicator",
  "volumeDropdown": "PrVpVa_volumeDropdown",
  "volumeSlider": "PrVpVa_volumeSlider",
});
